import React from "react";
import HRImages from "../../Constant/HRImages";

const LeaveRequestForm = ({ selectedEmployeeForm }) => {
  if (!selectedEmployeeForm) return null;

  console.log("Selected Employee Form:", selectedEmployeeForm);

  // Helper: Format date as DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "________________";
    try {
      const [day, month, year] = dateString.split("-");
      if (!day || !month || !year) return dateString;
      return `${day}/${month}/${year}`;
    } catch {
      return dateString;
    }
  };

  // Helper: Time duration
  const getTimeDuration = () => {
    if (!selectedEmployeeForm.startTime || !selectedEmployeeForm.endTime) {
      return "________________";
    }
    if (
      selectedEmployeeForm.leaveType === "PERMISSION" ||
      selectedEmployeeForm.leaveType === "HALFDAY"
    ) {
      return `${selectedEmployeeForm.startTime} - ${selectedEmployeeForm.endTime}`;
    }
    return "Full Day";
  };

  // Helper: Leave type text
  const getLeaveTypeText = () => {
    switch (selectedEmployeeForm.leaveType) {
      case "PERMISSION":
        return "Permission";
      case "HALFDAY":
        return "Half Day Leave";
      case "LEAVE":
        return "Leave";
      default:
        return selectedEmployeeForm.leaveType || "Unknown";
    }
  };

  // Helper: Communication mode
  const getCommunicationMode = () => {
    switch (selectedEmployeeForm.modeOfCommunication) {
      case "CALL":
        return "Call";
      case "VOICE":
        return "Voice";
      case "EMAIL":
        return "Email";
      case "TEXT":
        return "Text";
      case "IN_PERSON":
        return "In Person";
      default:
        return "Call / Voice / Text";
    }
  };

  return (
    <div
      className="bg-white mx-auto shadow"
      style={{
        fontFamily: "Arial, sans-serif",
        fontSize: "13px",
        width: "210mm", // A4 width
        height: "290mm", // A4 height
        padding: "15mm",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header */}
      <div className="text-center mb-4">
        <img
          src={HRImages.leaveFormHeader}
          alt="Header"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>

      {/* Title */}
      <h2 className="text-center text-lg font-bold text-teal-700 underline mb-6">
        {getLeaveTypeText()} Letter
      </h2>

      {/* Employee Details */}
      <div className="grid grid-cols-2 gap-8 mb-6">
        <div className="space-y-2">
          <p>
            <strong>Employee Name:</strong> {selectedEmployeeForm.name || "____"}
          </p>
          <p>
            <strong>Employee ID:</strong>{" "}
            {selectedEmployeeForm.employeeId || "____"}
          </p>
          <p>
            <strong>Department:</strong>{" "}
            {selectedEmployeeForm.teamNames?.join(", ") || "No Team"}
          </p>
        </div>
        <div className="space-y-2">
          <p>
            <strong>Date of Leave/Permission:</strong>{" "}
            {formatDate(selectedEmployeeForm.startDate)}
            {selectedEmployeeForm.endDate &&
            selectedEmployeeForm.endDate !== selectedEmployeeForm.startDate
              ? ` to ${formatDate(selectedEmployeeForm.endDate)}`
              : ""}
          </p>
          <p>
            <strong>Submission Date:</strong>{" "}
            {formatDate(selectedEmployeeForm.appliedDate)}
          </p>
          {(selectedEmployeeForm.leaveType === "PERMISSION" ||
            selectedEmployeeForm.leaveType === "HALFDAY") && (
            <p>
              <strong>Duration:</strong> {getTimeDuration()}
            </p>
          )}
        </div>
      </div>

      {/* Letter Body */}
      <div className="text-justify space-y-3 flex-1">
        <p>
          <strong>To.</strong>
          <br />
          NAMMA FAMILY BUILDER & DEVELOPER PVT. LTD
        </p>

        <p>
          <strong>Subject:</strong>{" "}
          <span className="text-teal-700 font-medium uppercase">
            {getLeaveTypeText()} Letter
          </span>
        </p>

        <p>Respected Sir/Madam,</p>

        <p>
          I would like to request{" "}
          <span className="font-medium">{getLeaveTypeText()}</span> on{" "}
          <span className="underline">
            {formatDate(selectedEmployeeForm.startDate)}
          </span>
          {selectedEmployeeForm.endDate &&
          selectedEmployeeForm.endDate !== selectedEmployeeForm.startDate
            ? ` to ${formatDate(selectedEmployeeForm.endDate)}`
            : ""}
          {(selectedEmployeeForm.leaveType === "PERMISSION" ||
            selectedEmployeeForm.leaveType === "HALFDAY") && (
            <>
              , between{" "}
              <span className="underline">{getTimeDuration()}</span> (hrs).
            </>
          )}
        </p>

        <p>
          Communication mode:{" "}
          <span className="underline">{getCommunicationMode()}</span>. Reason:{" "}
          <span className="underline">{selectedEmployeeForm.reason || "____"}</span>.
        </p>

        <p>
          I hand over my duties to{" "}
          <span className="underline">
            {selectedEmployeeForm.handoverTo === "Unknown"
              ? "No Handover"
              : selectedEmployeeForm.handoverTo || "____"}
          </span>{" "}
          during my absence. Kindly approve my request.
        </p>

        {selectedEmployeeForm.compensateType && (
          <p>
            I will compensate this leave on{" "}
            <span className="underline">
              {formatDate(selectedEmployeeForm.compensateDate)}
            </span>.
          </p>
        )}
      </div>

      {/* Signature */}
      <div className="mt-6">
        <p>
          Yours Sincerely,
          <br />
          <span className="block mt-4">
            Employee Name: {selectedEmployeeForm.name || "________________"}
          </span>
          <span className="block mt-2">
            Date: {formatDate(selectedEmployeeForm.appliedDate)}
          </span>
        </p>
      </div>

      {/* Status */}
      {selectedEmployeeForm.isApproved === "PENDING" && (
        <div className="mt-6 p-3 border rounded bg-yellow-50">
          <p className="font-bold text-center">Request Status: PENDING</p>
          <p className="mt-1 text-center text-xs text-gray-600">
            Your request is under review. You will be notified once a decision
            has been made.
          </p>
        </div>
      )}
      {selectedEmployeeForm.isApproved !== "PENDING" && (
        <div className="mt-6 p-3 border rounded bg-gray-50">
          <p className="font-bold text-center">Request Status</p>
          <p
            className={`text-center font-bold text-lg ${
              selectedEmployeeForm.isApproved === "APPROVED"
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {selectedEmployeeForm.isApproved}
          </p>
          {selectedEmployeeForm.isApproved === "REJECTED" &&
            selectedEmployeeForm.rejectionReason && (
              <p className="mt-1 text-center text-xs text-gray-600">
                <span className="font-medium">Reason:</span>{" "}
                {selectedEmployeeForm.rejectionReason}
              </p>
            )}
        </div>
      )}

      {/* Footer */}
      <div className="text-center mt-4">
        <img
          src={HRImages.leaveFormFooter}
          alt="Footer"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
    </div>
  );
};

export default LeaveRequestForm;